import React, {useState, useEffect} from 'react';
import '../App.css';
import TopBar  from '../components/Topbar';
import Footer  from '../components/Footer';
import CustomInput  from '../components/CustomInput';
import moment from 'moment';
import { MyProSidebarProvider } from "../components/SidebarContext";
import { Link, useParams } from 'react-router-dom';
import { baseUrl } from '../components/BaseUrl';
import axios from 'axios';
import Swal from "sweetalert2";
import GreetUser  from '../components/GreetUser';
import { CommentSection } from 'react-comments-section';
import Editable from "../components/Editable";
import 'react-comments-section/dist/index.css'

const data =[
    {
      userId: '02b',
      comId: '017',
      fullName: 'Lily',
      userProfile: 'https://www.linkedin.com/in/riya-negi-8879631a9/',
      text: 'I think you have a point🤔',
      avatarUrl: 'https://ui-avatars.com/api/name=Lily&background=random',
      replies: []
    }
  ]


const DiscussionDescription = () => {
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState([]);
  const [datas, setData] = useState([]);
  const { id } = useParams();
  useEffect(() => {
    fetchDiscussion();
    fetchComments();
  }, []);


const fetchDiscussion = () => {
const token = localStorage.getItem("codefussion-login-token");
    setLoading(true);
    const userData = {
      id: id
    };
    axios.post(`${baseUrl}get-discussion-by-id.php`, userData,
      { headers:
      { Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token
      }
    }).then((response) => {
      // console.log(response.data)
      if(response.data.status === 0){
        setLoading(false);
        Swal.fire({
          title: "Error!",
          text: "An error occurred. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }else{
         setComments(response.data);
         setLoading(false);
      }
    });
  };

  const fetchComments = () => {
  const token = localStorage.getItem("codefussion-login-token");
      setLoading(true);
      const userData = {
        id: id
      };
      axios.post(`${baseUrl}get-comment-by-id.php`, userData,
        { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      }).then((response) => {
        if(response.data.status === 0){
          setLoading(false);
          Swal.fire({
            title: "Error!",
            text: "An error occurred. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }else{
           setData(response.data);
           setLoading(false);
        }
      });
    };

  const postComment = (data) => {
  const token = localStorage.getItem("codefussion-login-token");
      // setLoading(true);
      // console.log(data)
      const userData = {
        user_id: data.userId,
        comment_id: data.comId,
        full_name: data.fullName,
        profile_url: data.userProfile,
        avatar_url: data.avatarUrl,
        message: data.text,
        replies: data.replies
      };
      axios.post(`${baseUrl}add-comment.php`, userData,
        { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      }).then((response) => {
        // console.log(userData.replies)
        // if(response.data.status === 0){
        //   // setLoading(false);
        //   Swal.fire({
        //     title: "Error!",
        //     text: "An error occurred. Please try again later.",
        //     icon: "error",
        //     confirmButtonText: "OK",
        //   });
        // }else if(response.data.status === 1){
        //    // setData(response.data);
        //    // setLoading(false);
        // }
      });
    };

  const showComments = () => {
    return(
    <div className="container" style={{ width: '100%' }}>
    <CommentSection
    currentUser={{
       currentUserId: `${id}`,
        // avatarUrl: "https://ui-avatars.com/api/name=Riya&background=random",
       currentUserImg:
       `${localStorage.getItem("codefussion-student-photo")}`,
       currentUserProfile:
       `${localStorage.getItem("codefussion-student-photo")}`,
       currentUserFullName: `${localStorage.getItem("codefussion-student-first-name")} ${localStorage.getItem("codefussion-student-last-name")}`
     }}
        // commentsArray={data}
     commentData={datas}
     hrStyle={{ border: '0.5px solid #ff0072' }}
        submitBtnStyle={{
          border: '1px solid black',
          padding: '7px 15px'
        }}
     onSubmitAction={(data: {
       userId: string,
       comId: string,
       avatarUrl?: string,
       userProfile?: string,
       fullName: string,
       text: string,
       replies: string,
       commentId: string,
     }) => postComment(data)}


     cancelBtnStyle={{
          border: '1px solid gray',
          backgroundColor: 'gray',
          color: 'white',
          padding: '7px 15px'
        }}
        advancedInput={true}
        replyInputStyle={{ borderBottom: '1px solid black', color: 'black' }}
      />

      </div>
    )
  }

  const showDiscussions = () => {
    return comments.map((item, index) => {
    return(
      <div className="container">
      <p>{item.message}</p>
      </div>
    )
    })
  }


  return (
    <MyProSidebarProvider>
    {localStorage.getItem("codefussion-login-token") === null ? window.location.replace("/login") :
    <div>
    <TopBar />
    <div className="container">
    {loading ?  <center>
        <div className="loader-wrapper" id="loading">
        <div className="loader">
        <div className="loader loader-inner"></div>
        </div>
        </div>
        </center> :
    <div>
   <h2 className="text-dark mt-4 font-weight-bold">Join the discussion</h2>
    <div style={{ width: '100%' }}>
     {showDiscussions()}
     {showComments()}
    </div>
    </div>}
    </div>
    </div>
    }
  </MyProSidebarProvider>
  );
}

export default DiscussionDescription;
